import gql from 'graphql-tag';
export const getId = gql`
  query GetId {
    viewer {
      _id
    }
  }
`;
